export default "__VITE_ASSET__C3P3TsBH__"